import { render, staticRenderFns } from "./EstimageMessageNewSideMenu.vue?vue&type=template&id=9575ccca"
import script from "./EstimageMessageNewSideMenu.vue?vue&type=script&lang=js"
export * from "./EstimageMessageNewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9575ccca')) {
      api.createRecord('9575ccca', component.options)
    } else {
      api.reload('9575ccca', component.options)
    }
    module.hot.accept("./EstimageMessageNewSideMenu.vue?vue&type=template&id=9575ccca", function () {
      api.rerender('9575ccca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageNewSideMenu.vue"
export default component.exports